import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lightning, Lock } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { endpoints, getToken, setToken } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  if (getToken()) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await endpoints.login(password);
      setToken(data.access_token);
      toast.success("Logged in");
      navigate("/", { replace: true });
    } catch (e) {
      const detail = e?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Login failed";
      setErr(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <Lightning size={28} weight="fill" className="text-signal-brand" />
          <div>
            <div className="font-heading font-black tracking-tight text-xl leading-none">
              FUTURES BOT
            </div>
            <div className="font-mono text-[10px] text-muted-foreground mt-1">
              v1.0 · BINANCE
            </div>
          </div>
        </div>
        <form
          onSubmit={submit}
          className="border border-border rounded-sm bg-[#0d0d0d] p-6 space-y-5"
        >
          <div>
            <div className="font-heading font-black text-2xl tracking-tight">
              Sign in
            </div>
            <div className="font-mono text-[11px] text-muted-foreground mt-1">
              Enter admin password to unlock dashboard
            </div>
          </div>
          <div>
            <Label className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              Password
            </Label>
            <div className="relative mt-2">
              <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <Input
                data-testid="login-password-input"
                type="password"
                autoFocus
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="rounded-sm pl-9 font-mono"
              />
            </div>
          </div>
          {err && (
            <div
              data-testid="login-error"
              className="text-[12px] text-signal-sell font-mono border border-signal-sell/30 bg-signal-sell/10 rounded-sm px-3 py-2"
            >
              {err}
            </div>
          )}
          <Button
            data-testid="login-submit-btn"
            type="submit"
            disabled={busy || !password}
            className="w-full rounded-sm bg-signal-brand hover:bg-signal-brand/90"
          >
            {busy ? "Signing in..." : "Sign In"}
          </Button>
        </form>
        <div className="font-mono text-[10px] text-muted-foreground text-center mt-4">
          Default password can be changed via ADMIN_PASSWORD in backend .env
        </div>
      </div>
    </div>
  );
}
